export default __webpack_public_path__ + "static/media/hero-students.08d66405.jpg";